import { Button, Card, CardContent, Progress } from "alm-react-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import { useNavigate } from "react-router-dom";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apis } from "../../../services/alm";
import { badgeUrl, seeAllProgramSection } from "../../../lib/utils";
import getLocalizedContent from "../../../lib/getLocalizedMetaData";
import { AppContext } from "../../../context/AppProvider";
import { constants } from "../../../assets/constants/constants";
import withAlmToken from "../../common/withAlmToken";
import PageLoader from "../../common/loader/PageLoader";
import useAlmCorporateStatus from "../../../hooks/useAlmCorporateStatus";

const MystanceAllPrograms=()=> {
  const [enrolledData, setEnrolledData] = useState<any>([]);
  const [included, setIncluded] = useState<any>([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { state } = useContext<any>(AppContext);
  useAlmCorporateStatus();

  useEffect(() => {
    const getAllPrograms = async () => {
      let finallresult: any = [];
      let finalIncluded: any = [];
      setLoading(true);
      if (state?.fundamenalCatlogId) {
        const response: any = await apis.getAllEnrolledStartedCompletedPrograms(
          state?.fundamenalCatlogId,
          constants.ACHIEVEMENTS
        );
        finallresult.push(response.data);
        finalIncluded.push(response?.included)
        let isTrue = response?.links?.next;
        while (isTrue) {
          const result: any = await apis.nextBaseUrl(isTrue);
          finallresult.push(result.data);
          finalIncluded.push(result.included)
          isTrue = result?.links?.next ? result?.links?.next : false;
        }
        setEnrolledData(finallresult.flat(1));
        setIncluded(finalIncluded.flat(1))
        setLoading(false);
      }
    };
    getAllPrograms();
  }, [state?.fundamenalCatlogId]);

  const progressPercentage = (res: any) => {
    return included
      .flat(1)
      ?.filter(
        (item: any) => res?.relationships?.enrollment?.data?.id === item?.id
      )[0]?.attributes?.progressPercent;
  };
  useLayoutEffect(() => {
    window.scroll(0, 0);
  });
  return (
    <>
      <div className="flex flex-col justify-between flex-grow">
        {loading ? (
          <PageLoader />
        ) : (
          <div
            key={"index" + Math.random()}
            className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow"
          >
            <div className="flex justify-between items-center">
              <Button
                onClick={() => navigate(`/home/my-stance`)}
                variant="default"
                className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
              >
                <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
              </Button>
            </div>
            <div className="w-[100%] mx-auto py-6 md:py-7">
              <div className="lg:flex lg:items-center lg:justify-between mb-4 md:mb-0">
                <div className="min-w-0 flex-1  md:pb-10">
                  <h1
                    className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light"
                    dangerouslySetInnerHTML={{
                      __html: t("MyStance.allProgram"),
                    }}
                  ></h1>
                </div>
              </div>
            </div>
            {seeAllProgramSection(enrolledData).length > 0 ? (
              seeAllProgramSection(enrolledData).map(
                (res: any, index: number) => {
                  const content = getLocalizedContent(
                    res?.attributes?.localizedMetadata
                  );
                  return (
                    <>
                      <div
                        key={"allprograms" + index}
                        className="w-[100%] mx-auto py-6 md:py-7"
                      >
                        <Card
                          key={"allprograms" + index}
                          className="dark:card-gradient-gray dark:text-white dark:border-cardBorder rounded-2xl"
                        >
                          <CardContent
                            key={"allprograms" + index}
                            className="grid gap-4 md:py-10 md:px-8 md:pb-7"
                          >
                            <div key={"allprograms" + index} className="flex max-md:flex-col-reverse">
                              <div className="flex-1 flex-col min-w-0 me-4">
                                <div className="flex justify-between pt-8 pb-14 md:flex-wrap lg:flex-nowrap max-md:flex-col max-md:justify-center max-md:text-center">
                                  <div className="flex flex-col w-full">
                                    <h1 className="scroll-m-20 text-2xl font-normal lg:text-3xl max-md:mb-5">
                                      {content?.name}
                                    </h1>
                                    <p className="leading-7 [&:not(:first-child)]:mt-4 md:w-[52%] hidden">
                                      {content?.overview}
                                    </p>
                                  </div>
                                  <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white mb-2 md:mt-5 lg:mt-0">
                                    <Button
                                      onClick={() =>
                                        navigate(`/program/${res?.id}`)
                                      }
                                      variant="outline"
                                      className="w-full max-md:w-auto mx-auto space-y-1.5 space-x-1.5 h-auto text-base font-normal bg-transparent py-1 md:min-h-10 md:px-14 dark:border-white"
                                    >
                                      {t("Program.goToProgram")}
                                      <FontAwesomeIcon
                                        icon={faArrowRight}
                                        className=" ms-3 text-sm"
                                      />
                                    </Button>
                                  </div>
                                </div>
                                <div className="flex items-center">
                                  <div className="flex-1 min-w-0">
                                    <Progress
                                      value={progressPercentage(res)}
                                      className="w-full h-[7px] bg-fillDarkGrayCard"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white">
                                <div
                                  className={`program-badge-lg ${
                                    progressPercentage(res) === 100
                                      ? "completed-program-badge"
                                      : ""
                                  }  m-auto mx-auto`}
                                >
                                  <img
                                    src={badgeUrl(
                                      res?.relationships?.instances?.data[0]
                                        ?.id,
                                      included
                                    )}
                                    className={` ${
                                      progressPercentage(res) === 100
                                        ? "yellow"
                                        : ""
                                    } program-badge-midimg max-w-[70px] max-h-[78px] w-[70px] lg:max-w-[88px] lg:max-h-[78px] lg:w-[88px] h-auto rounded-md`}
                                    alt="class overview video image"
                                  />
                                </div>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                    </>
                  );
                }
              )
            ) : (
              <div
                className="flex w-full justify-center text-2xl"
                dangerouslySetInnerHTML={{
                  __html: t("MyStance.noProgramsEnrolled"),
                }}
              ></div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default withAlmToken(MystanceAllPrograms);
